import {
  DocumentArrowDownIcon,
  EnvelopeIcon,
  LockClosedIcon,
} from '@heroicons/react/24/outline'
import { ReactComponent as LogoVirotrip } from 'images/logo_final_virotrip.svg'
import React from 'react'
import SocialsList1 from 'shared/SocialsList1/SocialsList1'

export interface WidgetFooterMenu {
  id: string
  title: string
}

const Footer: React.FC = () => {
  return (
    <footer className="flex border-t flex-col lg:flex-row justify-between h-36 lg:py-12">
      <div className="container mx-auto flex justify-between items-center gap-4">
        <div className="flex lg:flex-row flex-col ml-2 lg:justify-around lg:mx-auto w-full lg:ml-12 mt-4 lg:mt-0">
          <LogoVirotrip className="w-36 lg:w-44" />
          <div>
            <p className="hidden lg:block">Rede sociais</p>
            <SocialsList1 className="mt-2" />
          </div>
          <div>
            <p className="hidden lg:block">Contato</p>
            <a
              className="flex items-center text-sm lg:text-base"
              href="mailto:contato@virotrip.com.br"
            >
              <EnvelopeIcon className="hidden lg:block w-5 h-5 mr-2" />
              contato@virotrip.com.br
            </a>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row lg:gap-12 lg:ml-12 mt-4 lg:mt-0 gap-2 w-full lg:w-1/2">
          <div className="flex flex-col mt-4 lg:mt-0">
            <p>Termos e condições</p>
            <a
              className="mt-2 flex items-center text-sm lg:text-base"
              href="https://virotrip-public.s3.amazonaws.com/policies/termos-de-uso.pdf"
            >
              <DocumentArrowDownIcon className="lg:w-5 lg:h-5 w-4 h-4 mr-2" />
              Termos de uso
            </a>
            <a
              className="mt-2 flex items-center text-sm lg:text-base"
              href="https://virotrip-public.s3.amazonaws.com/policies/politicas-privacidade.pdf"
            >
              <LockClosedIcon className="lg:w-5 lg:h-5 w-4 h-4 mr-2" />
              Políticas de privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
